import { RealtimeClient } from './RealtimeClient';

export const realtimeClient = new RealtimeClient();
